/* Cocosymas · home rediseñado (2026). Interacciones de las secciones cy-*.
   Idempotente: se puede cargar varias veces y re-inicializar en el editor de temas. */
(function () {
  if (window.__cyHomeLoaded) return;
  window.__cyHomeLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function once(el, key) {
    if (el.getAttribute('data-cy-' + key) === '1') return false;
    el.setAttribute('data-cy-' + key, '1');
    return true;
  }

  /* --- Aparición al hacer scroll: solo se ocultan los bloques que están bajo el pliegue --- */
  var pending = [];
  var ticking = false;
  function revealCheck() {
    ticking = false;
    var vh = window.innerHeight;
    pending = pending.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) { el.classList.remove('cy-pre'); return false; }
      return true;
    });
  }
  function onRevealScroll() { if (!ticking) { ticking = true; requestAnimationFrame(revealCheck); } }
  function initReveal(root) {
    if (reduce) return;
    var vh = window.innerHeight;
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (!once(el, 'reveal')) return;
      if (el.getBoundingClientRect().top > vh * 0.95) { el.classList.add('cy-pre'); pending.push(el); }
    });
    setTimeout(revealCheck, 300);
    setTimeout(revealCheck, 1200);
    setTimeout(function () { pending.forEach(function (el) { el.classList.remove('cy-pre'); }); pending = []; }, 9000);
  }
  window.addEventListener('scroll', onRevealScroll, { passive: true });
  window.addEventListener('resize', onRevealScroll);

  /* --- Cifras del combo: cuentan cuando la banda entra en pantalla --- */
  function fmt(n, f) { return f === 'miles' ? n.toLocaleString('es-CO') : String(n); }
  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    var f = el.getAttribute('data-format');
    var t0 = null, dur = 1500;
    if (isNaN(target)) return;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      p = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * p), f);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initStats(root) {
    root.querySelectorAll('.cy-stats').forEach(function (band) {
      if (!once(band, 'stats')) return;
      var counters = band.querySelectorAll('[data-count]');
      if (!counters.length || reduce) return;
      var fired = false;
      function fire() { if (fired) return; fired = true; counters.forEach(countUp); }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { fire(); io.disconnect(); } });
        }, { threshold: 0.35 });
        io.observe(band);
      } else { fire(); }
    });
  }

  /* --- Termómetro: 22 °C es el punto de cambio (ficha técnica). Tres fotos del mismo tazón. --- */
  function clamp(v) { return Math.max(0, Math.min(1, v)); }
  function initTemp(root) {
    root.querySelectorAll('.cy-temp').forEach(function (wrap) {
      if (!once(wrap, 'temp')) return;
      var range = wrap.querySelector('.cy-range');
      var visual = wrap.querySelector('.cy-temp-visual');
      var label = wrap.querySelector('.cy-temp-label');
      var value = wrap.querySelector('.cy-temp-value');
      if (!range || !visual) return;
      var imgSol = visual.querySelector('.cy-t-sol'), imgSemi = visual.querySelector('.cy-t-semi'), imgLiq = visual.querySelector('.cy-t-liq');
      var txtSol = wrap.getAttribute('data-txt-sol') || 'Sólido y cremoso';
      var txtSemi = wrap.getAttribute('data-txt-semi') || 'Derritiéndose';
      var txtLiq = wrap.getAttribute('data-txt-liq') || 'Líquido y transparente';
      function setTemp(t) {
        var s = clamp((t - 19) / 6);
        if (imgSol) imgSol.style.opacity = 1 - clamp(s * 2);
        if (imgSemi) imgSemi.style.opacity = 1 - Math.abs(s * 2 - 1);
        if (imgLiq) imgLiq.style.opacity = clamp(s * 2 - 1);
        if (value) value.textContent = t;
        var txt = t < 21 ? txtSol : (t < 24 ? txtSemi : txtLiq);
        if (label) label.textContent = txt;
        range.setAttribute('aria-valuetext', t + ' grados, ' + txt.toLowerCase());
      }
      range.addEventListener('input', function () { setTemp(parseInt(range.value, 10)); });
      setTemp(parseInt(range.value, 10));
      if (!reduce && 'IntersectionObserver' in window) {
        var touched = false, dir = 1, timer = null;
        range.addEventListener('pointerdown', function () { touched = true; }, { once: true });
        var tio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !touched && !timer) {
              timer = setInterval(function () {
                if (touched) { clearInterval(timer); timer = null; return; }
                var t = parseInt(range.value, 10) + dir;
                if (t >= 30) dir = -1;
                if (t <= 14) dir = 1;
                range.value = t; setTemp(t);
              }, 240);
            } else if (!en.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.5 });
        tio.observe(visual);
      }
    });
  }

  /* --- Reseñas: duplicar la pista para el desplazamiento continuo --- */
  function initReviews(root) {
    root.querySelectorAll('.cy-reviews-track').forEach(function (track) {
      if (!once(track, 'dup') || reduce) return;
      track.innerHTML += track.innerHTML;
    });
  }

  /* --- Videos de clientes: se reproducen sobre el home, sin salir a YouTube.
         El enlace de la tarjeta no cambia; si el JS falla, sigue abriendo YouTube. --- */
  var vmodal = null, vopener = null, vscroll = '';
  function ytId(href) {
    var m = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/.exec(href || '');
    return m ? m[1] : null;
  }
  function onVideoKey(e) { if (e.key === 'Escape' || e.key === 'Esc') closeVideo(); }
  function closeVideo() {
    if (!vmodal) return;
    var m = vmodal;
    vmodal = null;
    document.removeEventListener('keydown', onVideoKey);
    document.documentElement.style.overflow = vscroll;
    m.classList.remove('cy-open');
    var frame = m.querySelector('iframe');
    if (frame) frame.src = 'about:blank';
    setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 260);
    if (vopener && vopener.focus) vopener.focus({ preventScroll: true });
  }
  function openVideo(id, title, opener) {
    closeVideo();
    vopener = opener;
    var m = document.createElement('div');
    m.className = 'cy-vmodal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', title || 'Video de cliente');
    var box = document.createElement('div');
    box.className = 'cy-vmodal-box';
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
    frame.title = title || 'Video de cliente';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.setAttribute('allowfullscreen', '');
    box.appendChild(frame);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cy-vmodal-close';
    btn.setAttribute('aria-label', 'Cerrar video');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    btn.addEventListener('click', closeVideo);
    m.appendChild(box);
    m.appendChild(btn);
    m.addEventListener('click', function (e) { if (e.target === m) closeVideo(); });
    vscroll = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(m);
    vmodal = m;
    document.addEventListener('keydown', onVideoKey);
    requestAnimationFrame(function () { m.classList.add('cy-open'); });
    btn.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var card = e.target && e.target.closest ? e.target.closest('.cy-vcard') : null;
    if (!card) return;
    var id = ytId(card.getAttribute('href'));
    if (!id) return;
    e.preventDefault();
    var img = card.querySelector('img');
    openVideo(id, img ? img.getAttribute('alt') : '', card);
  });

  function initAll(root) {
    root = root || document;
    initReveal(root); initStats(root); initTemp(root); initReviews(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* Editor de temas de Shopify: re-inicializar la sección recargada */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
